import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  messages: [], // array to store all messages
};

const whatsAppSlice = createSlice({
  name: "whatsApp",
  initialState,
  reducers: {
    // Add a new message
    addWhatsAppMessage: (state, action) => {
      const newMessage = action.payload;

      // Avoid duplicates by ID (optional)
      const exists = state.messages.find((msg) => msg.id === newMessage.id);
      if (!exists) {
        state.messages.push(newMessage);
      }
    },

    // Clear all messages
    clearWhatsAppMessages: (state) => {
      state.messages = [];
    },
  },
});

export const { addWhatsAppMessage, clearWhatsAppMessages } =
  whatsAppSlice.actions;

export const selectWhatsAppMessages = (state) => state.whatsApp.messages;

export default whatsAppSlice.reducer;
